// ── Adapter Supabase do IFilterOptionsRepository ──────────────────
// Queries cruas de funnels/pipelines/pipeline_stages usadas nos filtros.
// Retorna listas vazias quando o Supabase não está disponível.

import { getSupabase } from '@infra/supabase/client';
import type {
  IFilterOptionsRepository,
  FunnelRow,
  PipelineRow,
  StageRow,
} from '@modules/config';

export class SupabaseFilterOptionsRepository implements IFilterOptionsRepository {
  listFunnels = async (workspaceId: string): Promise<FunnelRow[]> => {
    const supabase = getSupabase();
    if (!supabase) return [];
    const { data, error } = await supabase
      .from('funnels')
      .select('id, name')
      .eq('workspace_id', workspaceId)
      .eq('ativo', true)
      .order('name');
    if (error) throw error;
    return (data || []) as unknown as FunnelRow[];
  };

  listPipelines = async (workspaceId: string): Promise<PipelineRow[]> => {
    const supabase = getSupabase();
    if (!supabase) return [];
    const { data, error } = await supabase
      .from('pipelines')
      .select('id, name, role, funnel_id')
      .eq('workspace_id', workspaceId)
      .eq('ativo', true)
      .order('role')
      .order('name');
    if (error) throw error;
    return (data || []) as unknown as PipelineRow[];
  };

  listStages = async (workspaceId: string): Promise<StageRow[]> => {
    const supabase = getSupabase();
    if (!supabase) return [];
    const { data, error } = await supabase
      .from('pipeline_stages')
      .select('id, name, pipeline_id, pipeline:pipelines!inner(id, name, role, funnel_id, workspace_id)')
      .eq('ativo', true)
      .eq('pipeline.workspace_id', workspaceId)
      .order('order_index');
    if (error) throw error;
    return (data || []) as unknown as StageRow[];
  };
}
